/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateOrderPaymentIntentInput = {
  readonly amount: number;
  readonly deliveryOrderDetail?: PaymentIntentDeliveryOrderDetail | null | undefined;
  readonly dropoffLocationId?: string | null | undefined;
  readonly includeUtensils?: boolean | null | undefined;
  readonly notificationType: string;
  readonly orderId: string;
  readonly orderType: string;
  readonly paymentMethodId?: string | null | undefined;
  readonly pickupTip?: number | null | undefined;
  readonly restaurantEntityId?: string | null | undefined;
  readonly restaurantId?: string | null | undefined;
  readonly restaurantSlug?: string | null | undefined;
  readonly shouldSetupFutureUsage?: boolean | null | undefined;
  readonly useCredit?: boolean | null | undefined;
  readonly useHsa?: boolean | null | undefined;
  readonly wantedTime: string;
};

export type PaymentIntentDeliveryOrderDetail = {
  readonly addressId: string | number;
  readonly deliveryFee: number;
  readonly tip: number;
  readonly vendor: string;
  readonly vendorRestaurantId: string;
};

export type CreateOrderPaymentIntentMutationVariables = Exact<{
  input: Types.CreateOrderPaymentIntentInput;
}>;

export type CreateOrderPaymentIntentMutation = {
  readonly createOrderPaymentIntent: {
    readonly __typename: 'PaymentIntent';
    readonly id: string;
    readonly secret: string;
  };
};

export const CreateOrderPaymentIntentDocument = gql`
  mutation CreateOrderPaymentIntent($input: CreateOrderPaymentIntentInput!) {
    createOrderPaymentIntent(input: $input) {
      __typename
      id
      secret
    }
  }
`;

export function useCreateOrderPaymentIntentMutation() {
  return Urql.useMutation<
    CreateOrderPaymentIntentMutation,
    CreateOrderPaymentIntentMutationVariables
  >(CreateOrderPaymentIntentDocument);
}
